<div class="col-md-12 col-xs-12" [formGroup]="form">
    <label>{{'assistance-form.education'| translate}}</label>
    <div formArrayName="myEducition" *ngFor="let item of myEducition.controls; let i = index;">
        <div [formGroupName]="i">
            <div class="row controls-group">

                <div class="col-md-1 col-xs-1">
                    <div>
                        <label> </label>
                        <div class="input-group">
                            <button class="btn icon" (click)="removeMyEducition(i)">X</button>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 col-xs-11">
                    <div>
                        <label>
                            {{'assistance-form.study-field'| translate}}
                        </label>
                        <div class="input-group">
                            <select class="form-control" (change)="change(i)" formControlName="studyField" id="{{'studyField' + i}}">
                                <option *ngFor="let it of baseService.taasuka" value="{{it.THUM_MIKZOA}}">{{it.TEUR_THUM}}</option>
                            </select>
                        </div>
                        <control-messages [control]="f2[i].controls.studyField"></control-messages>
                    </div>
                </div>

                <div class="col-md-5 col-xs-11">
                    <div *ngIf="required[i]">
                        <label mandatory>
                            {{'assistance-form.Degree-certificate'| translate}}
                        </label>
                    </div>
                    <div *ngIf="!required[i]">
                        <label>
                            {{'assistance-form.Degree-certificate'| translate}}
                        </label>
                    </div>
                    <div class="input-group">
                        <select class="form-control" formControlName="DegreeCertificate" id="{{'DegreeCertificate' + i}}">
                            <option *ngFor="let it2 of baseService.megama" value="{{it2.KOD}}">{{it2.TEUR}}</option>
                        </select>
                    </div>
                    <control-messages [control]="f2[i].controls.DegreeCertificate"></control-messages>
                </div>
            </div>

        </div>
    </div>
    <div class="row controls-group">
        <div class="col-md-12 col-xs-12">
            <div class="input-group">
                <button  type="button" class="btn small" (click)="addMyEducitionItem()">{{'add'| translate}}</button>
            </div>
        </div>
    </div>
</div>